/* eslint-disable react-hooks/exhaustive-deps */
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { TAX_SYSTEM_TYPE, VISUAL_CONFIG_CODES } from "@helpers/constantes";
import { useLazyGetVisualConfigQuery } from "@api/configuration";
import { ChecklistDocuments } from "@interfaces/catalogs";
import { DEFAULT_CHECKLIST_VISITA_OCULAR_PFAE, DEFAULT_CHECKLIST_VISITA_OCULAR_PM } from "@helpers/visualConfig";

const DocumentsForOcularVisit = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const application = useSelector((state: RootState) => state.register.application);
  const [getOnboardingConfig] = useLazyGetVisualConfigQuery();

  const defaultDocuments =
    application.tax_system_type === TAX_SYSTEM_TYPE.PFAE.code
      ? DEFAULT_CHECKLIST_VISITA_OCULAR_PFAE
      : DEFAULT_CHECKLIST_VISITA_OCULAR_PM;
  const [documentsRequired, setDocumentsRequired] = useState<ChecklistDocuments>(defaultDocuments);

  useEffect(() => {
    const defaults =
      application.tax_system_type === TAX_SYSTEM_TYPE.PFAE.code
        ? DEFAULT_CHECKLIST_VISITA_OCULAR_PFAE
        : DEFAULT_CHECKLIST_VISITA_OCULAR_PM;
    setDocumentsRequired(defaults);

    (async () => {
      try {
        if (!application.tax_system_id) {
          return;
        }

        const documents = await getOnboardingConfig({
          tax_system_id: application.tax_system_id,
          code: VISUAL_CONFIG_CODES.CHECKLIST_VISITA_OCULAR,
        }).unwrap();

        if (Array.isArray(documents) && documents.length && documents.every((item) => typeof item === "string")) {
          setDocumentsRequired(documents);
        }
      } catch (error) {
        console.log("Ha ocurrido un error", error);
      }
    })();
  }, [application.tax_system_id, application.tax_system_type]);

  return (
    <Box
      sx={{
        backgroundColor: theme?.palette?.components?.phoneInput?.main || theme?.palette?.primary?.base,
        borderRadius: "10px",
        padding: "20px",
      }}
    >
      <Typography fontWeight={600} color={theme?.palette?.primary?.dark} fontSize={"14px"} align="center">
        Recuerda que el día de la visita deberás presentar los siguientes documentos
      </Typography>

      <List>
        {documentsRequired.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemIcon sx={{ minWidth: "15px" }}>
              <Box width={12} height={12} mr={1} sx={{ backgroundColor: theme?.palette?.primary?.main }}></Box>
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant={isMobileOrTablet ? "body2" : "body1"}>{item}</Typography>}
              sx={{
                color: theme?.palette?.primary?.dark,
                fontWeight: 300,
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default DocumentsForOcularVisit;
